<template>
  <div class="flex flex-col gap-3 rounded-lg border border-gray-700 bg-secondary p-4 shadow-sm">
    <div class="mb-1 flex flex-col gap-2">
      <div class="flex items-start justify-between">
        <div class="flex flex-col">
          <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500"
            >Número de Série</span
          >
          <span class="font-mono text-xl font-bold tracking-wide text-white">{{
            item.serialNumber
          }}</span>
        </div>

        <div class="flex flex-col items-end">
          <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500">OP</span>
          <span
            class="mt-0.5 rounded bg-neon-green/10 px-2 py-0.5 font-mono text-sm font-bold text-neon-green"
          >
            {{ item.productionOrder?.orderNumber || '-' }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1 pt-1 text-sm text-gray-400">
      <div class="flex items-center justify-between">
        <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500">Modelo</span>
        <span class="truncate text-white">{{ item.productUnit.model || '-' }}</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500">Tamanho</span>
        <span class="text-white">{{ item.productUnit.size || '-' }}</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500">SKU</span>
        <span class="truncate break-all font-mono text-white">{{ item.productUnit.sku }}</span>
      </div>

      <div class="flex items-center justify-between">
        <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500">Cor</span>
        <div class="flex items-center gap-2">
          <span class="truncate text-[13px] capitalize text-white">
            {{ item.productUnit.color?.name?.toLowerCase() || '-' }}
          </span>
          <div
            v-if="item.productUnit.color?.hex"
            class="h-3 w-3 rounded-full shadow-sm"
            :style="{ backgroundColor: item.productUnit.color.hex }"
          ></div>
        </div>
      </div>
    </div>

    <div
      class="flex items-center justify-between border-t border-gray-700 pt-2 text-xs text-gray-400"
    >
      <span>Data de Apontamento</span>
      <span>{{ formattedDate }}</span>
    </div>

    <div
      v-if="item.conformant === false"
      class="flex w-full justify-center rounded bg-red-500/10 py-2"
    >
      <span class="text-[11px] font-bold uppercase tracking-widest text-red-500">
        Não Conforme
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { format, isToday, isYesterday } from 'date-fns'
import { ptBR } from 'date-fns/locale/pt-BR'
import type { ProductionDataDto } from '@/services/WarrantyApiService/types'

const props = defineProps<{
  item: ProductionDataDto
}>()

const formattedDate = computed(() => {
  if (!props.item?.appointedAt) return '-'
  try {
    const date = new Date(props.item.appointedAt)

    if (isToday(date)) {
      return `Hoje às ${format(date, 'HH:mm', { locale: ptBR })}`
    }

    if (isYesterday(date)) {
      return `Ontem às ${format(date, 'HH:mm', { locale: ptBR })}`
    }

    return format(date, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
  } catch (error) {
    return props.item.appointedAt.toString()
  }
})
</script>
